import React, { useRef, useState } from 'react';

import useClickOutside from '../../../common/hooks/useClickOutside';
import useTranslate from '../../../common/hooks/useTranslate';
// @ts-ignore
import EmailStore from '../../../common/services/config/emailStore';

import './contactTooltip.scss';

interface IContactTooltip {
  setTooltip: (state: boolean) => void;
  id?: string;
}

const ContactTooltip: React.FC<IContactTooltip> = ({ setTooltip, id }) => {
  const [copySuccess, setCopySuccess] = useState('');
  const wrapperRef = useRef(null);
  const { t } = useTranslate();

  const clickOutsideHandler = () => {
    setTooltip(false);
  };

  const copyToClipBoard = async (copyMe: string) => {
    try {
      await navigator.clipboard.writeText(copyMe);
      setCopySuccess(t('CONTACT_TOOLTIP.SUCCESS_TEXT'));
    } catch (err) {
      setCopySuccess(t('CONTACT_TOOLTIP.FAIL_TEXT'));
    }
  };

  useClickOutside(wrapperRef, clickOutsideHandler, id);

  return (
    <div className="contactTooltipWrapper" ref={wrapperRef}>
      <p className="info-header">{t('CONTACT_TOOLTIP.TEXT1')}</p>
      <p className="info">
        {t('CONTACT_TOOLTIP.TEXT2')} <a className="a1">{EmailStore.default_email}</a>
      </p>
      <button className="ctc" onClick={() => copyToClipBoard(EmailStore.default_email)}>
        {copySuccess ? copySuccess : t('CONTACT_TOOLTIP.BUTTON_COPY')}
      </button>
    </div>
  );
};

export default ContactTooltip;
